namespace $ {

	export const $bog_gamengine_studio_sample = [
		'$bog_gamengine_studio_sample $bog_gamengine_scene',
		'\tphys <= Phys $bog_gamengine_phys',
		'\t\ttile <= Tile',
		'\t\tbodies /',
		'\t\t\t<= Hero',
		'\tTile $bog_gamengine_phys_tile',
		'\t\tmap \\',
		'\t\t\t\\######',
		'\t\t\t\\#....#',
		'\t\t\t\\#..#.#',
		'\t\t\t\\#....#',
		'\t\t\t\\######',
		'\tkids /',
		'\t\t<= Tiles $bog_gamengine_tilemap',
		'\t\t\tname \\Карта',
		'\t\t\ttile <= Tile',
		'\t\t\tatlas <= Atlas',
		'\t\t\tpalette *',
		'\t\t\t\t# \\wall',
		'\t\t\t\t. \\floor',
		'\t\t<= Hero $bog_gamengine_phys_walker',
		'\t\t\tname \\Герой',
		'\t\t\tpos / 1.5 -1.5 0',
		'\t\t\tsize / 0.8 0.8',
		'\t\t\tspeed 3',
		'\t\t<= Hero_look $bog_gamengine_sprite',
		'\t\t\tname \\Вид героя',
		'\t\t\tparent <= Hero',
		'\t\t\tatlas <= Atlas',
		'\t\t\tframe \\hero',
		'\t\t<= Coin $bog_gamengine_sprite',
		'\t\t\tname \\Монета',
		'\t\t\tatlas <= Atlas',
		'\t\t\tframe \\coin',
		'\t\t\tpos / 4.5 -1.5 0',
		'\t\t<= Wall $bog_gamengine_sprite',
		'\t\t\tname \\Стена',
		'\t\t\tatlas <= Atlas',
		'\t\t\tframe \\wall',
		'\t\t\tpos / 3.5 -2.5 0',
		'\tAtlas $bog_gamengine_atlas',
		'\t\turis /',
		'\t\t\t\\bog/gamengine/demo/atlas/hero.png',
		'\t\t\t\\bog/gamengine/demo/atlas/coin.png',
		'\t\t\t\\bog/gamengine/demo/atlas/wall.png',
		'\t\t\t\\bog/gamengine/demo/atlas/floor.png',
		'\t\tsize 64',
	].join( '\n' ) + '\n'

	export const $bog_gamengine_studio_sample_tiles = [
		'$bog_gamengine_studio_sample_tiles $bog_gamengine_scene',
		'\tTile $bog_gamengine_phys_tile',
		'\t\tmap \\',
		'\t\t\t\\######',
		'\t\t\t\\#....#',
		'\t\t\t\\######',
		'\tkids /',
		'\t\t<= Tiles $bog_gamengine_tilemap',
		'\t\t\tname \\Карта',
		'\t\t\ttile <= Tile',
		'\t\t\tatlas <= Atlas',
		'\t\t\tpalette *',
		'\t\t\t\t# \\wall',
		'\t\t\t\t. \\floor',
		'\tAtlas $bog_gamengine_atlas',
		'\t\turis /',
		'\t\t\t\\bog/gamengine/demo/atlas/wall.png',
		'\t\t\t\\bog/gamengine/demo/atlas/floor.png',
		'\t\tsize 64',
	].join( '\n' ) + '\n'

	export const $bog_gamengine_studio_sample_shift = [
		'$bog_gamengine_studio_sample_shift $bog_gamengine_scene',
		'\tTile $bog_gamengine_phys_tile',
		'\t\torigin / 4 -3',
		'\t\tmap \\',
		'\t\t\t\\######',
		'\t\t\t\\#....#',
		'\t\t\t\\######',
		'\tkids /',
		'\t\t<= Tiles $bog_gamengine_tilemap',
		'\t\t\tname \\Карта',
		'\t\t\ttile <= Tile',
		'\t\t\tatlas <= Atlas',
		'\t\t\tpalette *',
		'\t\t\t\t# \\wall',
		'\t\t\t\t. \\floor',
		'\tAtlas $bog_gamengine_atlas',
		'\t\turis /',
		'\t\t\t\\bog/gamengine/demo/atlas/wall.png',
		'\t\t\t\\bog/gamengine/demo/atlas/floor.png',
		'\t\tsize 64',
	].join( '\n' ) + '\n'

	export const $bog_gamengine_studio_sample_brain = [
		'$bog_gamengine_studio_sample_brain $bog_gamengine_scene',
		'\tkids /',
		'\t\t<= Guard $bog_gamengine_brain_fsm',
		'\t\t\tname \\Сторож',
		'\t\t<= Walk $bog_gamengine_brain_state',
		'\t\t\tname \\Ходит',
		'\t\t\tnext /',
		'\t\t\t\t*',
		'\t\t\t\t\tto \\Ждёт',
		'\t\t\t\t\twhen \\near',
		'\t\t<= Wait $bog_gamengine_brain_state',
		'\t\t\tname \\Ждёт',
	].join( '\n' ) + '\n'

	export const $bog_gamengine_studio_sample_nest = [
		'$bog_gamengine_studio_sample_nest $bog_gamengine_scene',
		'\tkids /',
		'\t\t<= Guard $bog_gamengine_brain_fsm',
		'\t\t\tname \\Сторож',
		'\t\t\tkids /',
		'\t\t\t\t<= Walk $bog_gamengine_brain_state',
		'\t\t\t\t\tname \\Ходит',
		'\t\t\t\t\tpos / 1 0 0',
		'\t\t\t\t<= Wait $bog_gamengine_brain_state',
		'\t\t\t\t\tname \\Ждёт',
		'\t\t\t\t\tpos / 0 1 0',
		'\t\t<= Mark $bog_gamengine_node',
		'\t\t\tname \\Метка',
		'\t\t\tpos / 2 0 0',
	].join( '\n' ) + '\n'

	export const $bog_gamengine_studio_sample_prefab = [
		'$bog_gamengine_studio_sample_prefab $bog_gamengine_scene',
		'\tkids /',
		'\t\t<= Enemy_1 $bog_gamengine_studio_sample_guard',
		'\t\t\tpos / 1 0 0',
		'\t\t<= Enemy_2 $bog_gamengine_studio_sample_guard',
		'\t\t\tpos / 5 0 0',
		'\t\t\tname \\Вожак',
		'',
		'$bog_gamengine_studio_sample_guard $bog_gamengine_node',
		'\tname \\Страж',
		'\tkids /',
		'\t\t<= Gun $bog_gamengine_node',
		'\t\t\tname \\Ствол',
		'\t\t\tpos / 0 1 0',
	].join( '\n' ) + '\n'

}
